import React from 'react';
import { TextFieldProps } from '@material-ui/core';

import NumberMaskedField from '../../NumberMaskedField';

export type ExtFieldProps = TextFieldProps & {
  MaskedProps?: {
    format?: string;
  };
};

const defaultProps = {
  format: '######',
};

const ExtensionField = ({ MaskedProps, name, ...props }: ExtFieldProps): JSX.Element => {
  return <NumberMaskedField InputProps={{ name: name }} MaskedProps={{ ...MaskedProps, ...defaultProps }} {...props} />;
};

export default ExtensionField;
